// Firebase Modular Imports
import {
   initializeApp
} from 'firebase/app';
import { auth } from '../firebase/firebaseConfig';

import {
   getAuth,
   createUserWithEmailAndPassword,
   signInWithPopup,
   FacebookAuthProvider,
   GoogleAuthProvider,
   GithubAuthProvider,
   TwitterAuthProvider
} from 'firebase/auth';
import axios from 'axios';
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
   NotificationManager
} from 'react-notifications';
import {
   LOGIN_USER,
   LOGIN_USER_SUCCESS,
   LOGIN_USER_FAILURE,
   LOGOUT_USER,
   SIGNUP_USER,
   SIGNUP_USER_SUCCESS,
   SIGNUP_USER_FAILURE,
   FETCH_PARENT_DETAILS,
   SIGNUP_USER_REGISTER,
   SIGNUP_PASSWORD_SET,
   FORGOT_PASSWORD_SEND,
   TEAM_ACCEPT_TRAVEL,
   PARENT_ACCEPT_TRAVEL,
} from 'Actions/types';

// Firebase Config
const firebaseConfig = {
   apiKey: 'YOUR_API_KEY',
   authDomain: 'YOUR_AUTH_DOMAIN',
   projectId: 'YOUR_PROJECT_ID',
   storageBucket: 'YOUR_STORAGE_BUCKET',
   messagingSenderId: 'YOUR_MESSAGING_SENDER_ID',
   appId: 'YOUR_APP_ID'
};

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);

export const signinUserInFirebase = (user, navigate) => dispatch => {
   const payload = {
      username: user.email,
      password: user.password
   };
   const header = {
      'Access-Control-Allow-Origin': '*',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
   };

   axios.post(AppConfig.apiurl + '/api/applogin', payload, { headers: header })
      .then(response => {
         const resdata = response.data;
         const userdata = resdata.data;

         if (resdata.status === 1) {
            localStorage.setItem("authenticated", true);
            localStorage.setItem('user_id', userdata.userid);
            localStorage.setItem('user_name', userdata.name);
            localStorage.setItem('user_role', userdata.role);
            localStorage.setItem('token', userdata.authtoken);
            localStorage.setItem('token_type', userdata.token_type);
            localStorage.setItem('stdrole', userdata.studentrole);
            localStorage.setItem('user_academy', userdata.academy);

            AuthHeader.header = {
               'Authorization': `${userdata.token_type} ${userdata.authtoken}`
            };
            AuthHeader.gettoke = userdata.authtoken;

            dispatch({ type: LOGIN_USER_SUCCESS, payload: userdata.userid });

            if (userdata.role == 12) {
               navigate('/app/parentdashboard');
            } else if (userdata.role == 14) {
              navigate('/app/commondashboard');
            } else if (userdata.studentrole == 1) {
               navigate('/app/studentdashboard');
            } else {
               navigate('/app/dashboard');
            }

            NotificationManager.success('User Login Successfully!');
         } else {
            dispatch({ type: LOGIN_USER_FAILURE });
            NotificationManager.error(resdata.message);
         }
      })
      .catch(error => {
         NotificationManager.error(error.message);
      });
};

export const logoutUserFromFirebase = navigate => dispatch => {
   localStorage.clear();
   dispatch({ type: LOGOUT_USER });
   if (typeof navigate === 'function') {
      navigate('/');
   } else {
      window.location.href = '/';
   }
   NotificationManager.success('User Logout Successfully');
};

export const signupUserInFirebase = (user, navigate) => dispatch => {
   dispatch({ type: SIGNUP_USER });
   createUserWithEmailAndPassword(auth, user.email, user.password)
      .then(success => {
         localStorage.setItem("user_id", "user-id");
         dispatch({ type: SIGNUP_USER_SUCCESS, payload: localStorage.getItem('user_id') });
         navigate('/');
         NotificationManager.success('Account Created Successfully!');
      })
      .catch(error => {
         dispatch({ type: SIGNUP_USER_FAILURE });
         NotificationManager.error(error.message);
      });
};

const handleSocialLogin = (provider, navigate, dispatch) => {
   dispatch({ type: LOGIN_USER });
   signInWithPopup(auth, provider)
      .then(result => {
         localStorage.setItem("user_id", "user-id");
         dispatch({ type: LOGIN_USER_SUCCESS, payload: localStorage.getItem('user_id') });
         navigate('/');
         NotificationManager.success(`Hi ${result.user.displayName || 'User'}!`);
      })
      .catch(error => {
         dispatch({ type: LOGIN_USER_FAILURE });
         NotificationManager.error(error.message);
      });
};

export const signinUserWithFacebook = navigate => dispatch => handleSocialLogin(new FacebookAuthProvider(), navigate, dispatch);
export const signinUserWithGoogle = navigate => dispatch => handleSocialLogin(new GoogleAuthProvider(), navigate, dispatch);
export const signinUserWithGithub = navigate => dispatch => handleSocialLogin(new GithubAuthProvider(), navigate, dispatch);
export const signinUserWithTwitter = navigate => dispatch => handleSocialLogin(new TwitterAuthProvider(), navigate, dispatch);

export const fetchParentDetails = id => async dispatch => {
   dispatch({ type: LOGIN_USER });
   const payload = { id };
   const response = await axios.post(AppConfig.apiurl + '/api/getparentdetails', payload);
   dispatch({ type: FETCH_PARENT_DETAILS, payload: response.data.data });
   return response.data;
};

export const addRegisterForm = (data, pid, stdid) => async dispatch => {
   const payload = {
      parentid: pid,
      exstudentid: stdid,
      studentfname: data.target.stdfirstname.value,
      studentlname: data.target.stdlastname.value,
      studentemail: data.target.stdemail.value,
      studentmobile: data.target.stdmobile.value,
      studentdob: data.target.seldate.value,
      studentblood: data.target.stdblood.value,
      studentfood: data.target.stdfood.value,
      studentfoodallg: data.target.stdallergies.value,
      studentmedical: data.target.stdmedical.value,
      studentinformation: data.target.stdothers.value,
      parentname: data.target.prntname.value,
      parentemail: data.target.prntemail.value,
      parentmobile: data.target.prntmobile.value,
      parentage: data.target.selectage.value,
      address: data.target.address.value,
   };

   dispatch({ type: SIGNUP_USER });
   const response = await axios.post(AppConfig.apiurl + '/api/saveregisterdetails', payload);
   const resdata = response.data;

   resdata.status === 1 ? NotificationManager.success(resdata.message) : NotificationManager.error(resdata.message);
   dispatch({ type: SIGNUP_USER_REGISTER });
   return resdata;
};

export const addPasswordForm = (data, pid) => async dispatch => {
   const newpass = data.target.newpassword.value;
   const conpass = data.target.confirmpassword.value;

   if (newpass !== conpass) {
      NotificationManager.error('New password and confirm password not same');
      return;
   }

   const payload = {
      exuserid: pid,
      cnfpassword: conpass
   };

   dispatch({ type: SIGNUP_USER });
   const response = await axios.post(AppConfig.apiurl + '/api/savepassword', payload);
   NotificationManager.success(response.data.message);
   dispatch({ type: SIGNUP_PASSWORD_SET });
   return response.data;
};

export const addForgotPassword = email => async dispatch => {
   const payload = { email };
   dispatch({ type: SIGNUP_USER });
   const response = await axios.post(AppConfig.apiurl + '/api/forgetpasswordcheck', payload);
   NotificationManager.success(response.data.message);
   dispatch({ type: FORGOT_PASSWORD_SEND });
   return response.data;
};

const handleTravelForm = (url, data, pid, userid, actionid, type) => async dispatch => {
   const payload = {
      acceptid: pid,
      exuserid: userid,
      acceptname: data.target.acceptname.value,
      usraction: actionid,
      reasonmessage: actionid === 2 ? data.target.acceptname.value : ''
   };

   dispatch({ type: SIGNUP_USER });
   const response = await axios.post(AppConfig.apiurl + url, payload);
   NotificationManager.success(response.data.message);
   dispatch({ type });
   return response.data;
};

export const cocahAcceptTravel = (data, pid, userid, actionid) => handleTravelForm('/api/accepttravelform', data, pid, userid, actionid, TEAM_ACCEPT_TRAVEL);
export const parentAcceptTravel = (data, pid, userid, actionid) => handleTravelForm('/api/parentaccepttravelform', data, pid, userid, actionid, PARENT_ACCEPT_TRAVEL);
